import { render, staticRenderFns } from "./UrlAttributesDialog.vue?vue&type=template&id=661d802e&scoped=true&"
import script from "./UrlAttributesDialog.vue?vue&type=script&lang=js&"
export * from "./UrlAttributesDialog.vue?vue&type=script&lang=js&"
import style0 from "./UrlAttributesDialog.vue?vue&type=style&index=0&id=661d802e&lang=scss&scoped=true&"
import style1 from "./UrlAttributesDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661d802e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemContent,VTextField,VVirtualScroll})
